import { render, staticRenderFns } from "./wyf2024.vue?vue&type=template&id=2bd3b73c"
import script from "./wyf2024.vue?vue&type=script&lang=ts"
export * from "./wyf2024.vue?vue&type=script&lang=ts"
import style0 from "./wyf2024.vue?vue&type=style&index=0&id=2bd3b73c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadcrumbs: require('/builds/project/wyffest/frontend/components/app/AppBreadcrumbs.vue').default,WyfHero: require('/builds/project/wyffest/frontend/components/wyf/WyfHero.vue').default,WyfFeatures: require('/builds/project/wyffest/frontend/components/wyf/WyfFeatures.vue').default,WyfStats: require('/builds/project/wyffest/frontend/components/wyf/WyfStats.vue').default,WyfSymbolic: require('/builds/project/wyffest/frontend/components/wyf/WyfSymbolic.vue').default,WyfStories: require('/builds/project/wyffest/frontend/components/wyf/stories/WyfStories.vue').default})
